import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';

import Button from '@/components/Button';
import useResponsive from '@/hooks/useResponsive';

interface ActionButtonsProps {
  isCancelActive: (status?: string, statusCode?: string) => boolean;
  orderStatusNameES?: string;
  orderStatusCode?: string;
  withCancelPossibility: boolean;
  handleOpenCancelOrderModal: () => void;
  handleOpenDownloadModal: () => void;
  isOrderDelivered: (status?: string) => boolean;
}

const ActionButtons = ({
  isCancelActive,
  orderStatusNameES,
  orderStatusCode,
  withCancelPossibility,
  handleOpenCancelOrderModal,
  handleOpenDownloadModal,
  isOrderDelivered,
}: ActionButtonsProps) => {
  const isMobile = useResponsive('down', 'sm');
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: isMobile ? 'column-reverse' : 'row',
        justifyContent: 'end',
        alignItems: 'center',
        gap: '1rem',
      }}
    >
      {isCancelActive(orderStatusNameES, orderStatusCode) && withCancelPossibility && (
        <Button
          variant="contained"
          onClick={handleOpenCancelOrderModal}
          sx={{
            backgroundColor: theme.palette.dalia.light,
            color: theme.palette.dalia.main,
            ':hover': { boxShadow: `0 8px 16px 0 ${theme.palette.dalia.light}` },
          }}
        >
          Cancelar orden
        </Button>
      )}

      {isOrderDelivered(orderStatusNameES) && (
        <Button variant="contained" onClick={handleOpenDownloadModal}>
          Descargar etiqueta
        </Button>
      )}
    </Box>
  );
};

export default ActionButtons;
